import React from 'react';
import "./cards.css";
import youtube from "./images/bigyoutubewidget.png";
import git from "./images/githubwidget-p-500.png";
import profile from "./images/biglinkpreviewwidget.png";
import live from "./images/mapswidget.png";
import figma from "./images/figmawidget-p-500.png";
export default function CardSection() {
    return (
        <div className="card-section">
            <div className="column-1">
                <a href="https://jannabarrett.medium.com" target="_blank" rel="noopener noreferrer" className="link-block-2 w-inline-block">
                    <img
                        src="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/641f8948927bd57fc415a719_tallmediumwidget.png"
                        loading="lazy"
                        width="175"
                        height="390"
                        alt=""
                        srcSet="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/641f8948927bd57fc415a719_tallmediumwidget-p-500.png 500w, https://cdn.prod.website-files.com/6335b33630f88833a92915fc/641f8948927bd57fc415a719_tallmediumwidget.png 525w"
                        sizes="(max-width: 479px) 100vw, 175px"
                        className="image-26"
                    />
                </a>

                <div className="div-block-36-fake">
                    <img
                        src="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/6386329216092e3c35cd2615_placeholderwidget2.png"
                        loading="lazy"
                        width="175"
                        sizes="(max-width: 479px) 100vw, 175px"
                        alt=""
                        srcSet="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/6386329216092e3c35cd2615_placeholderwidget2-p-500.png 500w, https://cdn.prod.website-files.com/6335b33630f88833a92915fc/6386329216092e3c35cd2615_placeholderwidget2.png 525w"
                        className="image-20-fake"
                    />
                </div>

                <a href="https://open.spotify.com/episode/776Sr5qTjunPv2dNkQoODq" target="_blank" rel="noopener noreferrer" className="link-block-2 w-inline-block">
                    <img
                        src="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/641da7bd90faf7781c424550_tallspotifywidget.png"
                        loading="lazy"
                        width="175"
                        height="390"
                        alt=""
                        srcSet="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/641da7bd90faf7781c424550_tallspotifywidget-p-500.png 500w, https://cdn.prod.website-files.com/6335b33630f88833a92915fc/641da7bd90faf7781c424550_tallspotifywidget.png 525w"
                        sizes="(max-width: 479px) 100vw, 175px"
                        className="image-20"
                    />
                    <div
                        data-w-id="d09984f3-357b-8e91-928a-c0a47c801b3d"
                        style={{
                            transform: 'translate3d(0px, 0px, 0px) scale3d(4.9958, 4.9958, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)',
                            transformStyle: 'preserve-3d',
                            opacity: 0.000525,
                            filter: 'blur(0.39958px)',
                            willChange: 'filter, opacity, transform'
                        }}
                        className="div-block-341"
                    ></div>

                </a>
            </div>
            <div
                className="column-2"
            >
                <div className="small-row-right">
                    <div className="div-block-36-fake">
                        <img
                            src="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/63862fc970fe7f5125063eee_placeholderwidget1.png"
                            loading="lazy"
                            width="175"
                            sizes="(max-width: 479px) 100vw, 175px"
                            alt=""
                            srcSet="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/63862fc970fe7f5125063eee_placeholderwidget1-p-500.png 500w, https://cdn.prod.website-files.com/6335b33630f88833a92915fc/63862fc970fe7f5125063eee_placeholderwidget1.png 525w"
                            className="image-20-fake"
                        />
                    </div>
                </div>

                <a
                    href="#"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link-block-1 w-inline-block"
                >
                    <img
                        src="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/641da63bf960c442daf3636c_bigtextwidget.png"
                        loading="lazy"
                        width="390"
                        sizes="100vw"
                        alt=""
                        srcSet="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/641da63bf960c442daf3636c_bigtextwidget-p-500.png 500w, https://cdn.prod.website-files.com/6335b33630f88833a92915fc/641da63bf960c442daf3636c_bigtextwidget-p-800.png 800w, https://cdn.prod.website-files.com/6335b33630f88833a92915fc/641da63bf960c442daf3636c_bigtextwidget.png 1170w"
                        className="image-20"
                    />
                </a>

                <a
                    href="#"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link-block-1 w-inline-block"
                >
                    <img
                        src="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/639207e5abd89162bd81b491_bigcalendlywidget.png"
                        loading="lazy"
                        width="390"
                        sizes="100vw"
                        alt=""
                        srcSet="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/639207e5abd89162bd81b491_bigcalendlywidget-p-500.png 500w, https://cdn.prod.website-files.com/6335b33630f88833a92915fc/639207e5abd89162bd81b491_bigcalendlywidget-p-800.png 800w, https://cdn.prod.website-files.com/6335b33630f88833a92915fc/639207e5abd89162bd81b491_bigcalendlywidget.png 1170w"
                        className="image-20"
                    />
                </a>

                <a
                    href="/home/mugeeb"
                    className="link-block-338 w-inline-block"
                >
                    <img
                        className="image-20"
                        src="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/6390a8f1666cec4547e5807f_mediumphotowidget.png"
                        width="390"
                        height="175"
                        alt=""
                        draggable="false"
                        sizes="(max-width: 479px) 100vw, 390px"
                        loading="lazy"
                        srcSet="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/6390a8f1666cec4547e5807f_mediumphotowidget-p-500.png 500w, https://cdn.prod.website-files.com/6335b33630f88833a92915fc/6390a8f1666cec4547e5807f_mediumphotowidget-p-800.png 800w, https://cdn.prod.website-files.com/6335b33630f88833a92915fc/6390a8f1666cec4547e5807f_mediumphotowidget-p-1080.png 1080w, https://cdn.prod.website-files.com/6335b33630f88833a92915fc/6390a8f1666cec4547e5807f_mediumphotowidget.png 1170w"
                    />
                </a>

                <div className="small-row-right">
                    <a
                        href="https://apps.apple.com/de/app/camcord-vlog-your-story/id6443458187"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="link-block-3 w-inline-block"
                    >
                        <img
                            src="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/63951e93fd907e46335dd557_appstorewidget.png"
                            loading="lazy"
                            width="175"
                            sizes="(max-width: 479px) 100vw, 175px"
                            alt=""
                            srcSet="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/63951e93fd907e46335dd557_appstorewidget-p-500.png 500w, https://cdn.prod.website-files.com/6335b33630f88833a92915fc/63951e93fd907e46335dd557_appstorewidget.png 525w"
                            className="image-26"
                        />
                    </a>
                </div>
            </div>
            <div
                data-w-id="1324e53d-7f5a-99ac-7743-a594efa01f93"
                className="column-3"
                style={{
                    willChange: "transform",
                    transform:
                        "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                    transformStyle: "preserve-3d",
                }}
            >
                <a
                    href="https://www.youtube.com/@Oliur/videos"
                    target="_blank"
                    className="link-block-1 w-inline-block"
                >
                    <img
                        src="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/641dca4b67deea2ebb9ff2fb_bigyoutubewidget.png"
                        loading="lazy"
                        width="390"
                        sizes="100vw"
                        alt=""
                        srcSet="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/641dca4b67deea2ebb9ff2fb_bigyoutubewidget-p-500.png 500w, https://cdn.prod.website-files.com/6335b33630f88833a92915fc/641dca4b67deea2ebb9ff2fb_bigyoutubewidget-p-800.png 800w, https://cdn.prod.website-files.com/6335b33630f88833a92915fc/641dca4b67deea2ebb9ff2fb_bigyoutubewidget-p-1080.png 1080w, https://cdn.prod.website-files.com/6335b33630f88833a92915fc/641dca4b67deea2ebb9ff2fb_bigyoutubewidget.png 1170w"
                        className="image-26"
                    />
                </a>

                <a
                    href="https://github.com/CompVis/stable-diffusion"
                    target="_blank"
                    className="link-block-338 w-inline-block"
                >
                    <img
                        className="image-20"
                        src="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/63e91a49f16d3f275eb12ba7_githubwidget.png"
                        width="390"
                        height="175"
                        alt=""
                        draggable="false"
                        sizes="(max-width: 479px) 100vw, 390px"
                        loading="lazy"
                        srcSet="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/63e91a49f16d3f275eb12ba7_githubwidget-p-500.png 500w, https://cdn.prod.website-files.com/6335b33630f88833a92915fc/63e91a49f16d3f275eb12ba7_githubwidget-p-800.png 800w, https://cdn.prod.website-files.com/6335b33630f88833a92915fc/63e91a49f16d3f275eb12ba7_githubwidget.png 1170w"
                    />
                </a>

                <a
                    href="https://www.theverge.com/23298275/apple-severance-ben-stiller-ratings-viewers-emmys"
                    target="_blank"
                    className="link-block-1 w-inline-block"
                >
                    <img
                        src="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/641da63bc76ae68c29283f9d_biglinkpreviewwidget.png"
                        loading="lazy"
                        width="390"
                        sizes="100vw"
                        alt=""
                        srcSet="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/641da63bc76ae68c29283f9d_biglinkpreviewwidget-p-500.png 500w, https://cdn.prod.website-files.com/6335b33630f88833a92915fc/641da63bc76ae68c29283f9d_biglinkpreviewwidget-p-800.png 800w, https://cdn.prod.website-files.com/6335b33630f88833a92915fc/641da63bc76ae68c29283f9d_biglinkpreviewwidget-p-1080.png 1080w, https://cdn.prod.website-files.com/6335b33630f88833a92915fc/641da63bc76ae68c29283f9d_biglinkpreviewwidget.png 1170w"
                        className="image-20"
                    />
                </a>

                <a
                    href="https://www.google.com/maps/place/Berlin/@52.5069704,13.2846518,11z/data=!3m1!4b1!4m5!3m4!1s0x47a84e373f035901:0x42120465b5e3b70!8m2!3d52.5200066!4d13.404954"
                    target="_blank"
                    className="link-block-1 w-inline-block"
                >
                    <img
                        src="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/641f8e70197145b6992239a6_mapswidget.png"
                        loading="lazy"
                        width="390"
                        sizes="100vw"
                        alt=""
                        srcSet="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/641f8e70197145b6992239a6_mapswidget-p-500.png 500w, https://cdn.prod.website-files.com/6335b33630f88833a92915fc/641f8e70197145b6992239a6_mapswidget-p-800.png 800w, https://cdn.prod.website-files.com/6335b33630f88833a92915fc/641f8e70197145b6992239a6_mapswidget-p-1080.png 1080w, https://cdn.prod.website-files.com/6335b33630f88833a92915fc/641f8e70197145b6992239a6_mapswidget.png 1170w"
                        className="image-26"
                    />
                    <div
                        data-w-id="1324e53d-7f5a-99ac-7743-a594efa01f9d"
                        className="location-pulse"
                    ></div>
                    <img
                        src="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/641f8bc1885ad97e89fe433f_location.png"
                        loading="lazy"
                        width="26"
                        alt=""
                        className="image-21"
                    />
                </a>

                <a
                    href="https://www.figma.com/community/file/1121065701252736567"
                    target="_blank"
                    className="link-block-48-special w-inline-block"
                >
                    <img
                        className="image-47"
                        src="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/639520175e186c707418930b_figmawidget.png"
                        width="390"
                        height="67"
                        alt=""
                        draggable="false"
                        sizes="(max-width: 479px) 100vw, 390px"
                        data-w-id="7f1c5895-5c19-bcc5-e631-84b1c0785d3c"
                        loading="lazy"
                        srcSet="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/639520175e186c707418930b_figmawidget-p-500.png 500w, https://cdn.prod.website-files.com/6335b33630f88833a92915fc/639520175e186c707418930b_figmawidget-p-800.png 800w, https://cdn.prod.website-files.com/6335b33630f88833a92915fc/639520175e186c707418930b_figmawidget-p-1080.png 1080w, https://cdn.prod.website-files.com/6335b33630f88833a92915fc/639520175e186c707418930b_figmawidget.png 1171w"
                    />
                </a>
            </div>
            <div

                className="column-4"
            >
                <div className="div-block-36-fake">
                    <img
                        src="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/638634c3beb03c1e0fa29e0a_placeholderwidget3.png"
                        loading="lazy"
                        width="175"
                        sizes="(max-width: 479px) 100vw, 175px"
                        alt=""
                        srcSet="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/638634c3beb03c1e0fa29e0a_placeholderwidget3-p-500.png 500w, https://cdn.prod.website-files.com/6335b33630f88833a92915fc/638634c3beb03c1e0fa29e0a_placeholderwidget3.png 525w"
                        className="image-20-fake"
                    />
                </div>
                <div className="div-block-36-empty">
                    <img
                        src="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/638634c3beb03c1e0fa29e0a_placeholderwidget3.png"
                        loading="lazy"
                        width="175"
                        sizes="(max-width: 479px) 100vw, 175px"
                        alt=""
                        srcSet="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/638634c3beb03c1e0fa29e0a_placeholderwidget3-p-500.png 500w, https://cdn.prod.website-files.com/6335b33630f88833a92915fc/638634c3beb03c1e0fa29e0a_placeholderwidget3.png 525w"
                        className="image-20"
                    />
                </div>
                <a href="https://www.instagram.com/rogie/" target="_blank" className="link-block-2 w-inline-block">
                    <img
                        src="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/63ebcd583d088274b088fd2c_instagramwidget.png"
                        loading="lazy"
                        width="175"
                        sizes="(max-width: 479px) 100vw, 175px"
                        alt=""
                        srcSet="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/63ebcd583d088274b088fd2c_instagramwidget-p-500.png 500w, https://cdn.prod.website-files.com/6335b33630f88833a92915fc/63ebcd583d088274b088fd2c_instagramwidget.png 525w"
                        className="image-20"
                    />
                </a>
                <div className="div-block-36-fake-2">
                    <img
                        src="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/63862fc970fe7f5125063eee_placeholderwidget1.png"
                        loading="lazy"
                        width="175"
                        sizes="100vw"
                        alt=""
                        srcSet="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/63862fc970fe7f5125063eee_placeholderwidget1-p-500.png 500w, https://cdn.prod.website-files.com/6335b33630f88833a92915fc/63862fc970fe7f5125063eee_placeholderwidget1.png 525w"
                        className="image-20-fake"
                    />
                </div>
                <div className="div-block-36-empty">
                    <img
                        src="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/638634c3beb03c1e0fa29e0a_placeholderwidget3.png"
                        loading="lazy"
                        width="175"
                        sizes="(max-width: 479px) 100vw, 175px"
                        alt=""
                        srcSet="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/638634c3beb03c1e0fa29e0a_placeholderwidget3-p-500.png 500w, https://cdn.prod.website-files.com/6335b33630f88833a92915fc/638634c3beb03c1e0fa29e0a_placeholderwidget3.png 525w"
                        className="image-20"
                    />
                </div>
                <a href="https://www.producthunt.com/posts/bento-7?utm_source=badge-featured&amp;utm_medium=badge&amp;utm_souce=badge-bento-7" target="_blank" className="link-block-3 w-inline-block">
                    <img
                        src="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/641da90539e1a3b546be60d1_producthuntwidget.png"
                        loading="lazy"
                        width="175"
                        sizes="(max-width: 479px) 100vw, 175px"
                        alt=""
                        srcSet="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/641da90539e1a3b546be60d1_producthuntwidget-p-500.png 500w, https://cdn.prod.website-files.com/6335b33630f88833a92915fc/641da90539e1a3b546be60d1_producthuntwidget.png 525w"
                        className="image-20"
                    />
                </a>
            </div>
            <div className="column-5">
                <a href="https://www.youtube.com/watch?v=I1qsF0WQy8c" target="_blank" rel="noopener noreferrer" className="div-block-37 w-inline-block">
                    <img
                        src="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/641da63b8b57573439876b1b_bigyoutubewidget.png"
                        loading="lazy"
                        width="390"
                        sizes="100vw"
                        alt=""
                        srcSet="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/641da63b8b57573439876b1b_bigyoutubewidget-p-500.png 500w, https://cdn.prod.website-files.com/6335b33630f88833a92915fc/641da63b8b57573439876b1b_bigyoutubewidget-p-800.png 800w, https://cdn.prod.website-files.com/6335b33630f88833a92915fc/641da63b8b57573439876b1b_bigyoutubewidget-p-1080.png 1080w, https://cdn.prod.website-files.com/6335b33630f88833a92915fc/641da63b8b57573439876b1b_bigyoutubewidget.png 1170w"
                        className="image-20"
                    />
                </a>
                <div className="div-block-108">
                    <div className="div-block-107">
                        <a href="https://twitter.com/sdw/status/1544742309077684230" target="_blank" rel="noopener noreferrer" className="div-block-39 w-inline-block">
                            <img
                                src="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/641da63b84263a3a0d6a703d_tallmediumwidget.png"
                                loading="lazy"
                                width="175"
                                height="390"
                                alt=""
                                srcSet="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/641da63b84263a3a0d6a703d_tallmediumwidget-p-500.png 500w, https://cdn.prod.website-files.com/6335b33630f88833a92915fc/641da63b84263a3a0d6a703d_tallmediumwidget.png 525w"
                                sizes="(max-width: 479px) 42vw, 100vw"
                                className="image-20"
                            />
                        </a>
                        <a href="https://www.patreon.com/KevinNaughtonJr" target="_blank" rel="noopener noreferrer" className="div-block-36 w-inline-block">
                            <img
                                src="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/63ea7d42d96b453e6c24c20f_hero%20buymeacoffee.png"
                                loading="lazy"
                                width="175"
                                sizes="(max-width: 479px) 42vw, 100vw"
                                alt=""
                                srcSet="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/63ea7d42d96b453e6c24c20f_hero%20buymeacoffee-p-500.png 500w, https://cdn.prod.website-files.com/6335b33630f88833a92915fc/63ea7d42d96b453e6c24c20f_hero%20buymeacoffee.png 525w"
                                className="image-20"
                            />
                        </a>
                    </div>
                    <div className="div-block-107">
                        <a href="https://dribbble.com/Gavin" target="_blank" rel="noopener noreferrer" className="div-block-36 w-inline-block">
                            <img
                                src="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/63920b9e863b1e28d6b9bba9_dribbblewidget.png"
                                loading="lazy"
                                width="175"
                                sizes="(max-width: 479px) 42vw, 100vw"
                                alt=""
                                srcSet="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/63920b9e863b1e28d6b9bba9_dribbblewidget-p-500.png 500w, https://cdn.prod.website-files.com/6335b33630f88833a92915fc/63920b9e863b1e28d6b9bba9_dribbblewidget.png 525w"
                                className="image-20"
                            />
                        </a>
                        <a href="https://open.spotify.com/show/47jQcyRcrM1EoV0sU39N9F" target="_blank" rel="noopener noreferrer" className="div-block-78 w-inline-block">
                            <img
                                src="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/641da7bd90faf7781c424550_tallspotifywidget.png"
                                loading="lazy"
                                width="175"
                                height="390"
                                alt=""
                                srcSet="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/641da7bd90faf7781c424550_tallspotifywidget-p-500.png 500w, https://cdn.prod.website-files.com/6335b33630f88833a92915fc/641da7bd90faf7781c424550_tallspotifywidget.png 525w"
                                sizes="(max-width: 479px) 42vw, 100vw"
                                className="image-20"
                            />
                        </a>
                    </div>
                </div>
                <a href="#" target="_blank" rel="noopener noreferrer" className="div-block-37 w-inline-block">
                    <img
                        src="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/639207e5abd89162bd81b491_bigcalendlywidget.png"
                        loading="lazy"
                        width="390"
                        sizes="100vw"
                        alt=""
                        srcSet="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/639207e5abd89162bd81b491_bigcalendlywidget-p-500.png 500w, https://cdn.prod.website-files.com/6335b33630f88833a92915fc/639207e5abd89162bd81b491_bigcalendlywidget-p-800.png 800w, https://cdn.prod.website-files.com/6335b33630f88833a92915fc/639207e5abd89162bd81b491_bigcalendlywidget.png 1170w"
                        className="image-20"
                    />
                </a>
                <a href="/home/mugeeb" className="div-block-38 w-inline-block">
                    <img
                        className="image-20"
                        src="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/6390a8f1666cec4547e5807f_mediumphotowidget.png"
                        width="390"
                        height="175"
                        alt=""
                        draggable="false"
                        sizes="(max-width: 479px) 90vw, 100vw"
                        loading="lazy"
                        srcSet="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/6390a8f1666cec4547e5807f_mediumphotowidget-p-500.png 500w, https://cdn.prod.website-files.com/6335b33630f88833a92915fc/6390a8f1666cec4547e5807f_mediumphotowidget-p-800.png 800w, https://cdn.prod.website-files.com/6335b33630f88833a92915fc/6390a8f1666cec4547e5807f_mediumphotowidget-p-1080.png 1080w, https://cdn.prod.website-files.com/6335b33630f88833a92915fc/6390a8f1666cec4547e5807f_mediumphotowidget.png 1170w"
                    />
                </a>
                <a
                    pointer-events="none"
                    data-w-id="2afa32b0-a7be-38da-9b4a-8eeb69ea06c9"
                    href="https://www.figma.com/community/file/1121065701252736567"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link-block-48-special-mobile w-inline-block"
                >
                    <img
                        className="image-47"
                        src="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/639520175e186c707418930b_figmawidget.png"
                        width="390"
                        height="67"
                        alt=""
                        draggable="false"
                        sizes="(max-width: 479px) 90vw, 100vw"
                        data-w-id="2afa32b0-a7be-38da-9b4a-8eeb69ea06ca"
                        loading="lazy"
                        srcSet="https://cdn.prod.website-files.com/6335b33630f88833a92915fc/639520175e186c707418930b_figmawidget-p-500.png 500w, https://cdn.prod.website-files.com/6335b33630f88833a92915fc/639520175e186c707418930b_figmawidget-p-800.png 800w, https://cdn.prod.website-files.com/6335b33630f88833a92915fc/639520175e186c707418930b_figmawidget-p-1080.png 1080w, https://cdn.prod.website-files.com/6335b33630f88833a92915fc/639520175e186c707418930b_figmawidget.png 1171w"
                    />
                </a>
            </div>
        </div>
    );
}
